import { defineRelations } from 'drizzle-orm'
import * as schema from './schema'

export const relations = defineRelations(schema, (r) => ({
    usersTable: {
        vendor: r.one.vendorsTable({
            from: r.usersTable.vendorId,
            to: r.vendorsTable.id,
            optional: true,
        }),
        client: r.one.clientsTable({
            from: r.usersTable.clientId,
            to: r.clientsTable.id,
            optional: true,
        }),
        createdBenefits: r.many.benefitsTable({
            from: r.usersTable.id,
            to: r.benefitsTable.creatorId,
        }),
        createdVendorAccess: r.many.clientVendorAccessTable({
            from: r.usersTable.id,
            to: r.clientVendorAccessTable.createdByUserId,
        }),
        benefitApplications: r.many.benefitApplicationsTable({
            from: r.usersTable.id,
            to: r.benefitApplicationsTable.employeeId,
        }),
        drawnRaffles: r.many.rafflesTable({
            from: r.usersTable.id,
            to: r.rafflesTable.drawnByUserId,
        }),
        benefitRecents: r.many.benefitRecentTable({
            from: r.usersTable.id,
            to: r.benefitRecentTable.userId,
        }),
    },

    serviceProviderCategoriesTable: {
        vendors: r.many.vendorsTable({
            from: r.serviceProviderCategoriesTable.id,
            to: r.vendorsTable.categoryId,
        }),
        benefits: r.many.benefitsTable({
            from: r.serviceProviderCategoriesTable.id,
            to: r.benefitsTable.serviceProviderCategoryId,
        }),
    },

    vendorsTable: {
        category: r.one.serviceProviderCategoriesTable({
            from: r.vendorsTable.categoryId,
            to: r.serviceProviderCategoriesTable.id,
            optional: false,
        }),
        users: r.many.usersTable({
            from: r.vendorsTable.id,
            to: r.usersTable.vendorId,
        }),
        benefits: r.many.benefitsTable({
            from: r.vendorsTable.id,
            to: r.benefitsTable.vendorId,
        }),
        clientAccess: r.many.clientVendorAccessTable({
            from: r.vendorsTable.id,
            to: r.clientVendorAccessTable.vendorId,
        }),
    },

    clientsTable: {
        users: r.many.usersTable({
            from: r.clientsTable.id,
            to: r.usersTable.clientId,
        }),
        benefitTargets: r.many.benefitClientTargetsTable({
            from: r.clientsTable.id,
            to: r.benefitClientTargetsTable.clientId,
        }),
        vendorAccess: r.many.clientVendorAccessTable({
            from: r.clientsTable.id,
            to: r.clientVendorAccessTable.clientId,
        }),
        benefitApplications: r.many.benefitApplicationsTable({
            from: r.clientsTable.id,
            to: r.benefitApplicationsTable.clientId,
        }),
        benefitRecents: r.many.benefitRecentTable({
            from: r.clientsTable.id,
            to: r.benefitRecentTable.clientId,
        }),
    },

    benefitsTable: {
        vendor: r.one.vendorsTable({
            from: r.benefitsTable.vendorId,
            to: r.vendorsTable.id,
            optional: false,
        }),
        category: r.one.serviceProviderCategoriesTable({
            from: r.benefitsTable.serviceProviderCategoryId,
            to: r.serviceProviderCategoriesTable.id,
            optional: false,
        }),
        creator: r.one.usersTable({
            from: r.benefitsTable.creatorId,
            to: r.usersTable.id,
            optional: true,
        }),
        clientTargets: r.many.benefitClientTargetsTable({
            from: r.benefitsTable.id,
            to: r.benefitClientTargetsTable.benefitId,
        }),
        applications: r.many.benefitApplicationsTable({
            from: r.benefitsTable.id,
            to: r.benefitApplicationsTable.benefitId,
        }),
        raffle: r.one.rafflesTable({
            from: r.benefitsTable.id,
            to: r.rafflesTable.benefitId,
            optional: true,
        }),
        images: r.many.benefitImagesTable({
            from: r.benefitsTable.id,
            to: r.benefitImagesTable.benefitId,
        }),
        benefitRecents: r.many.benefitRecentTable({
            from: r.benefitsTable.id,
            to: r.benefitRecentTable.benefitId,
        }),
    },

    benefitClientTargetsTable: {
        benefit: r.one.benefitsTable({
            from: r.benefitClientTargetsTable.benefitId,
            to: r.benefitsTable.id,
            optional: false,
        }),
        client: r.one.clientsTable({
            from: r.benefitClientTargetsTable.clientId,
            to: r.clientsTable.id,
            optional: false,
        }),
    },

    clientVendorAccessTable: {
        client: r.one.clientsTable({
            from: r.clientVendorAccessTable.clientId,
            to: r.clientsTable.id,
            optional: false,
        }),
        vendor: r.one.vendorsTable({
            from: r.clientVendorAccessTable.vendorId,
            to: r.vendorsTable.id,
            optional: false,
        }),
        createdBy: r.one.usersTable({
            from: r.clientVendorAccessTable.createdByUserId,
            to: r.usersTable.id,
            optional: true,
        }),
    },

    benefitApplicationsTable: {
        benefit: r.one.benefitsTable({
            from: r.benefitApplicationsTable.benefitId,
            to: r.benefitsTable.id,
            optional: false,
        }),
        employee: r.one.usersTable({
            from: r.benefitApplicationsTable.employeeId,
            to: r.usersTable.id,
            optional: true,
        }),
        client: r.one.clientsTable({
            from: r.benefitApplicationsTable.clientId,
            to: r.clientsTable.id,
            optional: true,
        }),
        voucher: r.one.vouchersTable({
            from: r.benefitApplicationsTable.id,
            to: r.vouchersTable.benefitApplicationId,
            optional: true,
        }),
        raffleWinner: r.one.raffleWinnersTable({
            from: r.benefitApplicationsTable.id,
            to: r.raffleWinnersTable.benefitApplicationId,
            optional: true,
        }),
    },

    vouchersTable: {
        application: r.one.benefitApplicationsTable({
            from: r.vouchersTable.benefitApplicationId,
            to: r.benefitApplicationsTable.id,
            optional: false,
        }),
    },

    rafflesTable: {
        benefit: r.one.benefitsTable({
            from: r.rafflesTable.benefitId,
            to: r.benefitsTable.id,
            optional: false,
        }),
        drawnBy: r.one.usersTable({
            from: r.rafflesTable.drawnByUserId,
            to: r.usersTable.id,
            optional: true,
        }),
        winners: r.many.raffleWinnersTable({
            from: r.rafflesTable.id,
            to: r.raffleWinnersTable.raffleId,
        }),
    },

    raffleWinnersTable: {
        raffle: r.one.rafflesTable({
            from: r.raffleWinnersTable.raffleId,
            to: r.rafflesTable.id,
            optional: false,
        }),
        application: r.one.benefitApplicationsTable({
            from: r.raffleWinnersTable.benefitApplicationId,
            to: r.benefitApplicationsTable.id,
            optional: false,
        }),
    },

    benefitImagesTable: {
        benefit: r.one.benefitsTable({
            from: r.benefitImagesTable.benefitId,
            to: r.benefitsTable.id,
            optional: false,
        }),
    },

    benefitRecentTable: {
        user: r.one.usersTable({
            from: r.benefitRecentTable.userId,
            to: r.usersTable.id,
            optional: true,
        }),
        client: r.one.clientsTable({
            from: r.benefitRecentTable.clientId,
            to: r.clientsTable.id,
            optional: true,
        }),
        benefit: r.one.benefitsTable({
            from: r.benefitRecentTable.benefitId,
            to: r.benefitsTable.id,
            optional: false,
        }),
    },
}))
